/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'

import { fetchData, toasterrormsg, toastsuccessmsg } from '../../../../../../reusable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'

const SignInMethod: React.FC = () => {

  const [showPasswordForm, setPasswordForm] = useState<boolean>(false)
  const clearFields = () =>{
    setOldPassword("");
    setNewPassword("");
    setRetypePassword("");
  }
  const [loading2, setLoading2] = useState(false)

  const [adminData,setAdminData]=useState(Object)

  // change password state
  const [oldPassword,setOldPassword]=useState("")
  const [newPassword,setNewPassword]=useState("")
  const [retypePassword,setRetypePassword]=useState("")
  const [oldPasswordDisplay,setOldPasswordDisplay]=useState(false)
  const [newPasswordDisplay,setNewPasswordDisplay]=useState(false)
  const [retypePasswordDisplay,setRetypePasswordDisplay]=useState(false)

  const [error,setError]=useState(Object)

  const validpassword=()=>{
    var err=0
    var tmp:any={
        oldPasswordError:"",
        newPasswordError:"",
        retypePasswordError:""
    }

    if(oldPassword=="" || oldPassword==null || oldPassword==undefined)
    {        toasterrormsg("Current Password Required");
        err=1
    }

    if(newPassword=="" || newPassword==null || newPassword==undefined)
    {
        toasterrormsg("New Password Is Required");
        err=1
      }
      
      if(retypePassword=="" || retypePassword==null || retypePassword==undefined)
      {
        toasterrormsg("Confirm Password Required");
        err=1
      }
      
      else if(newPassword!=retypePassword)
      {
        toasterrormsg("New Password And Confirm Password Are Not Same");
        err=1
    }
    if(err==0)
    {
        changepasswordapi()
    }

}

const changepasswordapi=async()=>{
    var param:any={
        "adminId":String(adminData['adminId']),
        "currentpassword":oldPassword,
        "newpassword":newPassword
    }

    var response:any=await fetchData("admin/changepassword",param)
    
    if(response.status=="200")
    {
        toastsuccessmsg("Password Changed Successfully")
        
        setTimeout(() => {
            window.location.reload()
          }, 2000);
    }
    else
    {
        toasterrormsg(response.message)
    }
}
// action function end
useEffect(()=>{
  var admin:any=sessionStorage.getItem("admin");
  setAdminData(JSON.parse(admin))
},[])

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0 cursor-pointer'
        role='button'
        data-bs-toggle='collapse'
        data-bs-target='#kt_account_signin_method'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Sign-in Method</h3>
        </div>
      </div>

      <div id='kt_account_signin_method' className='collapse show'>
        <div className='card-body border-top p-9'>


          <div className='d-flex flex-wrap align-items-center mb-10'>
            <div id='kt_signin_password' className={' ' + (showPasswordForm && 'd-none')}>
              <div className='fs-6 fw-bolder mb-1'>Password</div>
              <div className='fw-bold text-gray-600'>************</div>
            </div>

            <div
              id='kt_signin_password_edit'
              className={'flex-row-fluid ' + (!showPasswordForm && 'd-none')}
            >
              <div
                id='kt_signin_change_password'
                className='form'
              >
                <div className='row mb-1'>
                  <div className='col-lg-4'>
                    <div className='fv-row mb-0'>
                      <label htmlFor='currentpassword' className='form-label fs-6 fw-bolder mb-3'>
                        Current Password
                      </label>
                      <div className="fv-row fv-plugins-icon-container" style={{position:"relative"}}>
                        <input type={oldPasswordDisplay==false?"password":"text"} name="currentPassword" className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" placeholder="Current Password" value={oldPassword} onChange={(e:any)=>setOldPassword(e.target.value)} />
                        <span className="cursor-pointer"  style={{position:"absolute",top:"25%",right:"20px"}} title={oldPasswordDisplay==true?"Hide":"Show"} onClick={()=>setOldPasswordDisplay(!oldPasswordDisplay)}><FontAwesomeIcon icon={oldPasswordDisplay==true?faEyeSlash:faEye}/></span>
                      </div>
                    </div>
                  </div>

                  <div className='col-lg-4'>
                    <div className='fv-row mb-0'>
                      <label htmlFor='newpassword' className='form-label fs-6 fw-bolder mb-3'>
                        New Password
                      </label>
                      <div className="fv-row fv-plugins-icon-container" style={{position:"relative"}}>
                        <input type={newPasswordDisplay==false?"password":"text"} name="newPassword" id="newPassword" className="form-control form-control-lg form-control-solid" placeholder="New Password" value={newPassword} onChange={(e:any)=>setNewPassword(e.target.value)} />
                        <span className="cursor-pointer"  style={{position:"absolute",top:"25%",right:"20px"}} title={newPasswordDisplay==true?"Hide":"Show"} onClick={()=>setNewPasswordDisplay(!newPasswordDisplay)}><FontAwesomeIcon icon={newPasswordDisplay==true?faEyeSlash:faEye}/></span>
                      </div>
                    </div>
                  </div>

                  <div className='col-lg-4'>
                    <div className='fv-row mb-0'>
                      <label htmlFor='confirmpassword' className='form-label fs-6 fw-bolder mb-3'>
                        Confirm New Password
                      </label>
                      <div className="fv-row fv-plugins-icon-container" style={{position:"relative"}}>
                        <input type={retypePasswordDisplay==false?"password":"text"} name="confirmPassword" id="confirmPassword" className="form-control form-control-lg form-control-solid" placeholder="Confirm Password"  value={retypePassword} onChange={(e:any)=>setRetypePassword(e.target.value)} />
                        <span className="cursor-pointer" style={{position:"absolute",top:"25%",right:"20px"}} title={retypePasswordDisplay==true?"Hide":"Show"} onClick={()=>setRetypePasswordDisplay(!retypePasswordDisplay)}><FontAwesomeIcon icon={retypePasswordDisplay==true?faEyeSlash:faEye}/></span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='d-flex mt-5'>
                  <button
                    id='kt_password_submit'
                    type='button'
                    className='btn btn-success monthBtn me-2 px-6'
                    onClick={()=>validpassword()}
                  >
                    {!loading2 && 'Update Password'}
                    {loading2 && (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Please wait...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                  <button
                    onClick={() => {
                      setPasswordForm(false)
                    }}
                    id='kt_password_cancel'
                    type='button'
                    className='btn btn-color-gray-400 btn-active-light-success px-6'
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <div
              id='kt_signin_password_button'
              className={'ms-auto ' + (showPasswordForm && 'd-none')}
            >
              <button
                onClick={() => {
                  setPasswordForm(true);
                  clearFields();
                }}
                className='btn btn-light btn-active-light-success'
              >
                Reset Password
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {SignInMethod}
